<template>
    <!-- 用户签名页面 -->
    <div class="main">
        <div v-show="is_sign_page" class="sign">
            <div class="sign_title_box">
                根据证监会的要求，并保证您的合法权益，
                <br />请您在红色方框内签字：
            </div>
            <div id="canvasBox" ref="canvasBox">
                <div v-if="options">
                    <sign-canvas
                        class="sign-canvas"
                        ref="SignCanvas"
                        :options="options"
                        v-model="value"
                    />
                </div>
            </div>
            <!-- 用来比较是否空白 -->
            <div id="canvasBox2" ref="canvasBox2">
                <div v-if="options">
                    <sign-canvas
                        class="sign-canvas"
                        ref="SignCanvas2"
                        :options="options"
                        v-model="value"
                    />
                </div>
            </div>
            <div class="ft">
                <button class="clearBtn" @click="canvasClear">清空内容</button>
                <button class="outputBtn" @click="saveAsImg">确定签字</button>
            </div>
            
        </div>
    </div>
</template>

<script>
import PaymentApi from '@/api/gold/detail.js'

export default {
    name: "signAgreement",
    data() {
        return {
            cdnPath: "https://img1-cdn-picsh.stock-ring.com/",
            value: null,
            options: null,
            is_sign_page: true,
            isSigning: false,
            l_id:this.$route.query.l_id, 
            u_id:0,
            agreement_id:this.$route.query.agreement_id,//合同id
            order:this.$route.query.order, //支付的订单号
            name:this.$route.query.name, //姓名
            number:this.$route.query.number, //身份证号

        };
    },
    components: {

    },
    created() {
        if(this.$store && this.$store.state && this.$store.state.user.userId){
            this.u_id =  this.$store.state.user.userId;
        }
    },
    mounted() {
        this.$nextTick(()=>{
            //直接显示签字
            this.setCanvas('canvasBox');
            this.setCanvas('canvasBox2');
        })

    },
    updated() {},
    methods: {
        // 获取文件对象 转换成它的url暂缓地址
        getObjectURL(file) {
            var url = null;
            if (window.createObjcectURL != undefined) {
                url = window.createOjcectURL(file);
            } else if (window.URL != undefined) {
                url = window.URL.createObjectURL(file);
            } else if (window.webkitURL != undefined) {
                url = window.webkitURL.createObjectURL(file);
            }
            return url;
        },
        //传入图片路径，返回base64
        getBase64(img) {
            function getBase64Image(img, width, height) {//width、height调用时传入具体像素值，控制大小 ,不传则默认图像大小
                var canvas = document.createElement("canvas");
                canvas.width = width ? width : img.width;
                canvas.height = height ? height : img.height;
                var ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                var dataURL = canvas.toDataURL();
                return dataURL;
            }
            var image = new Image();
            image.crossOrigin = '';
            image.src = img;
            var deferred = $.Deferred();
            if (img) {
                image.onload = function () {
                deferred.resolve(getBase64Image(image));//将base64传给done上传处理
                }
                return deferred.promise();
            }
        },
        //签字相关
        isCanvasBlank(canvas) {
            let blank = this.$refs.canvasBox2.querySelector("canvas");
            console.log(canvas,blank,canvas.toDataURL() == blank.toDataURL(),'???')
            return canvas.toDataURL() == blank.toDataURL(); //比较值相等则为空
        },
        //设置 setCanvas
        setCanvas(ref) {
            let that = this;
            let timer = null;
            timer = setTimeout(() => {
                let canvasBox = this.$refs[ref];
                let _w = canvasBox.offsetWidth;
                let _h = canvasBox.offsetHeight;
                console.log(canvasBox, _w, _h);
                this.options = {
                    lastWriteSpeed: 1, //书写速度 [Number] 可选
                    lastWriteWidth: 2, //下笔的宽度 [Number] 可选
                    lineCap: "round", //线条的边缘类型 [butt]平直的边缘 [round]圆形线帽 [square]    正方形线帽
                    lineJoin: "round", //线条交汇时边角的类型  [bevel]创建斜角 [round]创建圆角 [miter]创建尖角。
                    canvasWidth: _w, //canvas宽高 [Number] 可选
                    canvasHeight: _h, //高度  [Number] 可选
                    isShowBorder: false, //是否显示边框 [可选]
                    bgColor: "#fff", //背景色 [String] 可选
                    borderWidth: 1, // 网格线宽度  [Number] 可选
                    borderColor: "#ff787f", //网格颜色  [String] 可选
                    writeWidth: 5, //基础轨迹宽度  [Number] 可选
                    maxWriteWidth: 30, // 写字模式最大线宽  [Number] 可选
                    minWriteWidth: 5, // 写字模式最小线宽  [Number] 可选
                    writeColor: "#101010", // 轨迹颜色  [String] 可选
                    isSign: true, //签名模式 [Boolean] 默认为非签名模式,有线框, 当设置为true的时候没有任何线框
                    imgType: "png", //下载的图片格式  [String] 可选为 jpeg  canvas本是透明背景的
                };
                clearTimeout(timer);
                if(ref == 'canvasBox2'){
                    $('#canvasBox2').hide();
                }
            }, 10);
        },
        /**
         * 清除画板
         */
        canvasClear() {
            this.$refs.SignCanvas.canvasClear();
        },
        //cavans 转变 base64 传参
        saveAsImg() {
            let _this = this;
            let canvas = this.$refs.canvasBox.querySelector("canvas");
            if (this.isSigning) {
                return;
            }
            this.isSigning = true;
            const img = this.$refs.SignCanvas.saveAsImg(); //base64
            function dataURLtoFile(dataURI, type) {
                let binary = atob(dataURI.split(",")[1]);
                let array = [];
                for (let i = 0; i < binary.length; i++) {
                    array.push(binary.charCodeAt(i));
                }
                return new Blob([new Uint8Array(array)], { type: type });
            }
            let file = dataURLtoFile(img, "image/jpeg");
            if (this.isCanvasBlank(canvas)) {
                this.$message.error("请签字后确定！");
                this.isSigning = false;
            } else {
                
                console.log('file',file)
                var objURL = _this.getObjectURL(file);
				// 获取64
				_this.getBase64(objURL).then(function (base64) {
					let _base64 = base64.substring(base64.indexOf(",") + 1);
					_this.signImg = _base64;
                    _this.$message.success("操作成功，等待签约结果！");
					_this.agreementSign();

				}, function (err) {
					console.log(err);//打印异常信息
				});
            }
        },
        //签约接口
        async agreementSign() {
            let res = await PaymentApi.agreementSign({
                //不知道其他参数有啥
                image: this.signImg,
                u_id:this.u_id,
                user_id:this.u_id,
                l_id:this.l_id,
                truename:this.name,
                idcard:this.number,
                order_id:this.order,
                agreement_id:this.agreement_id,
            });
            if (res.rslt === "succ") {
                let timer = null;
                this.$message.success("签约成功!");
                timer = setTimeout(() => {
                    location.href = `/lives/center/id/${this.l_id}.html`
                    clearTimeout(timer);
                }, 3000);
            } else {
                this.isSigning = false;
                this.$message.error("签约失败，请稍后再试或联系客服！");
            }
        },

        /**
         * 下载图片
         */
        downloadSignImg() {
            this.$refs.SignCanvas.downloadSignImg();
        },
    },
};
</script>



<style scoped lang="scss">
@import "~@/assets/sass/global.scss";
.main {
    padding-top: rem2(0.1px);
    min-height: 100vh;
}

.sign {
    padding: 0 rem2(15px) 0 rem2(15px);
}
.sign_title_box {
    margin: rem2(10px) 0 rem2(15px) 0;
    line-height: rem2(20px);
    color: #333;
    font-size: rem2(13px);
}
#canvasBox, #canvasBox2{
    background: #fff;
    border: 1px solid #ff5353;
    overflow: hidden;
    height: rem2(440px);
}
// #canvasBox2{
//     position: absolute;
//     left: 1000000000000000000000px;
//     top: 1000000000000000000000px;
// }
.outputBtn,
.clearBtn {
    margin-top: rem2(20px);
    width: rem2(139px);
    height: rem2(44px);
    background: rgba(255, 255, 255, 1);
    border-radius: 10px;
    border: none;
    outline: none;
    float: left;
    font-size: rem2(15px);
}
.outputBtn {
    float: right;
    background: #fe484a;
    color: #fff;
}
</style>
